import {
  CreatePaylinkWithApiDto,
  DepositCustomerEntity,
  CreateDepositCustomerDto,
} from '@heliofi/common';
import { ApiAdapter } from '../ApiAdapter';

export class DepositSDK {
  constructor(private apiAdapter: ApiAdapter) {}

  async create(
    createDepositCustomerDto: CreateDepositCustomerDto,
  ): Promise<DepositCustomerEntity> {
    return this.apiAdapter.post(
      '/deposit-customers/api-key',
      createDepositCustomerDto,
      'Failed to create deposit customer',
    );
  }
}
